import { render } from "./Bingocard.vue?vue&type=template&id=4aeeef43&scoped=true"
import script from "./Bingocard.vue?vue&type=script&lang=js"
export * from "./Bingocard.vue?vue&type=script&lang=js"

import "./Bingocard.vue?vue&type=style&index=0&id=4aeeef43&lang=scss&scoped=true"

import exportComponent from "/Users/magsin/Projects/sommarfest2022/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aeeef43"]])

export default __exports__